// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"39b4495a","787":"60235f71"}[chunkId] + ".chunk.js";
};